import React from 'react';

import { LookbookListingCard } from '../components/lookbook';
import { useUpsertLookbook } from '../useUpsertLookbook';

export function LookbookListingRow({ listing, ...rest }) {
  const { isListingSelected, toggleListing } = useUpsertLookbook();

  return (
    <div className="lb-select-listings__item col-12">
      <LookbookListingCard
        listing={listing}
        selected={isListingSelected(listing)}
        onSelectToggle={() => toggleListing(listing)}
        {...rest}
      />
    </div>
  );
}
